export function getConfiguration() {
    return {
        serverURL: 'https://transactions-api.decentraland.io/v1'
    };
}
//# sourceMappingURL=configuration.js.map